import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mm-table-option',
  templateUrl: './table-option.component.html',
  styleUrls: ['./table-option.component.scss']
})
export class TableOptionComponent implements OnInit {

  @Input() schwabIcon: string | null;
  @Input() text: string;

  constructor() { }

  ngOnInit(): void {
  }

}
